<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9234_68254)">
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint0_radial_9234_68254)"
      />
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint1_radial_9234_68254)"
      />
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint2_linear_9234_68254)"
      />
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint3_linear_9234_68254)"
      />
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint4_radial_9234_68254)"
      />
      <path d="M27.8307 7.41027C28.3007 6.87027 27.9107 6.03027 27.1907 6.03027H4.8407C4.1207 6.03027 3.7407 6.87027 4.2007 7.41027L15.0107 20.0303V27.3503H11.7907C10.8107 27.3503 10.0207 28.1403 10.0207 29.1203V30.0303H22.0207V29.1203C22.0207 28.1403 21.2307 27.3503 20.2507 27.3503H17.0207V20.0303L27.8307 7.41027Z"
            fill="url(#paint5_radial_9234_68254)"
      />
      <path d="M11.7905 27.3501C10.8105 27.3501 10.0205 28.1401 10.0205 29.1201V30.0301H22.0205V29.1201C22.0205 28.1401 21.2305 27.3501 20.2505 27.3501C9.39393 27.3501 23.331 27.3501 11.7905 27.3501Z"
            fill="url(#paint6_linear_9234_68254)"
      />
      <path d="M11.7905 27.3501C10.8105 27.3501 10.0205 28.1401 10.0205 29.1201V30.0301H22.0205V29.1201C22.0205 28.1401 21.2305 27.3501 20.2505 27.3501C9.39393 27.3501 23.331 27.3501 11.7905 27.3501Z"
            fill="url(#paint7_radial_9234_68254)"
      />
      <path d="M11.7905 27.3501C10.8105 27.3501 10.0205 28.1401 10.0205 29.1201V30.0301H22.0205V29.1201C22.0205 28.1401 21.2305 27.3501 20.2505 27.3501C9.39393 27.3501 23.331 27.3501 11.7905 27.3501Z"
            fill="url(#paint8_radial_9234_68254)"
      />
      <path d="M15.0108 20.0303V27.3503C6.12233 27.3503 17.5243 27.3503 17.0208 27.3503V20.0303H15.0108Z"
            fill="url(#paint9_linear_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="#A5EB78"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint10_radial_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint11_radial_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint12_radial_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint13_linear_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint14_radial_9234_68254)"
      />
      <path d="M14.4406 18.1003L8.00059 10.2303C7.61059 9.75027 7.95059 9.03027 8.57059 9.03027H23.4606C24.0806 9.03027 24.4206 9.75027 24.0306 10.2303L17.6006 18.1003C16.7806 19.1003 15.2606 19.1003 14.4406 18.1003Z"
            fill="url(#paint15_radial_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6501 2.02626C20.9119 2.11435 21.0526 2.39793 20.9645 2.65964L16.4945 15.9396C16.4064 16.2014 16.1229 16.3421 15.8611 16.254C15.5994 16.1659 15.4587 15.8823 15.5468 15.6206L20.0168 2.34063C20.1049 2.07892 20.3884 1.93817 20.6501 2.02626Z"
            fill="url(#paint16_linear_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6501 2.02626C20.9119 2.11435 21.0526 2.39793 20.9645 2.65964L16.4945 15.9396C16.4064 16.2014 16.1229 16.3421 15.8611 16.254C15.5994 16.1659 15.4587 15.8823 15.5468 15.6206L20.0168 2.34063C20.1049 2.07892 20.3884 1.93817 20.6501 2.02626Z"
            fill="url(#paint17_linear_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6501 2.02626C20.9119 2.11435 21.0526 2.39793 20.9645 2.65964L16.4945 15.9396C16.4064 16.2014 16.1229 16.3421 15.8611 16.254C15.5994 16.1659 15.4587 15.8823 15.5468 15.6206L20.0168 2.34063C20.1049 2.07892 20.3884 1.93817 20.6501 2.02626Z"
            fill="url(#paint18_radial_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6501 2.02626C20.9119 2.11435 21.0526 2.39793 20.9645 2.65964L16.4945 15.9396C16.4064 16.2014 16.1229 16.3421 15.8611 16.254C15.5994 16.1659 15.4587 15.8823 15.5468 15.6206L20.0168 2.34063C20.1049 2.07892 20.3884 1.93817 20.6501 2.02626Z"
            fill="url(#paint19_radial_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6501 2.02626C20.9119 2.11435 21.0526 2.39793 20.9645 2.65964L16.4945 15.9396C16.4064 16.2014 16.1229 16.3421 15.8611 16.254C15.5994 16.1659 15.4587 15.8823 15.5468 15.6206L20.0168 2.34063C20.1049 2.07892 20.3884 1.93817 20.6501 2.02626Z"
            fill="url(#paint20_linear_9234_68254)"
      />
      <path d="M17.9507 12.1602C19.1823 12.1602 20.1807 11.1618 20.1807 9.9302C20.1807 8.6986 19.1823 7.7002 17.9507 7.7002C16.7191 7.7002 15.7207 8.6986 15.7207 9.9302C15.7207 11.1618 16.7191 12.1602 17.9507 12.1602Z"
            fill="#398072"
      />
      <path d="M17.9507 12.1602C19.1823 12.1602 20.1807 11.1618 20.1807 9.9302C20.1807 8.6986 19.1823 7.7002 17.9507 7.7002C16.7191 7.7002 15.7207 8.6986 15.7207 9.9302C15.7207 11.1618 16.7191 12.1602 17.9507 12.1602Z"
            fill="url(#paint21_radial_9234_68254)"
      />
      <path d="M17.9507 12.1601C19.1823 12.1601 20.1807 11.1617 20.1807 9.93009C20.1807 9.6216 20.1181 9.32775 20.0048 9.06055H15.8966C15.7833 9.32775 15.7207 9.6216 15.7207 9.93009C15.7207 11.1617 16.7191 12.1601 17.9507 12.1601Z"
            fill="#398974"
      />
      <path d="M17.9507 12.1601C19.1823 12.1601 20.1807 11.1617 20.1807 9.93009C20.1807 9.6216 20.1181 9.32775 20.0048 9.06055H15.8966C15.7833 9.32775 15.7207 9.6216 15.7207 9.93009C15.7207 11.1617 16.7191 12.1601 17.9507 12.1601Z"
            fill="url(#paint22_radial_9234_68254)"
      />
      <path d="M17.9507 12.1601C19.1823 12.1601 20.1807 11.1617 20.1807 9.93009C20.1807 9.6216 20.1181 9.32775 20.0048 9.06055H15.8966C15.7833 9.32775 15.7207 9.6216 15.7207 9.93009C15.7207 11.1617 16.7191 12.1601 17.9507 12.1601Z"
            fill="url(#paint23_linear_9234_68254)"
      />
      <path d="M17.9507 12.1601C19.1823 12.1601 20.1807 11.1617 20.1807 9.93009C20.1807 9.6216 20.1181 9.32775 20.0048 9.06055H15.8966C15.7833 9.32775 15.7207 9.6216 15.7207 9.93009C15.7207 11.1617 16.7191 12.1601 17.9507 12.1601Z"
            fill="url(#paint24_radial_9234_68254)"
      />
      <path d="M18.2405 9.81013C18.0405 10.4101 17.4405 10.7401 16.9005 10.5601C16.3605 10.3801 16.0905 9.75013 16.2905 9.15013C16.4905 8.55013 17.0905 8.22013 17.6305 8.40013C18.1705 8.58013 18.4405 9.21013 18.2405 9.81013Z"
            fill="#FA684C"
      />
      <path d="M18.2405 9.81013C18.0405 10.4101 17.4405 10.7401 16.9005 10.5601C16.3605 10.3801 16.0905 9.75013 16.2905 9.15013C16.4905 8.55013 17.0905 8.22013 17.6305 8.40013C18.1705 8.58013 18.4405 9.21013 18.2405 9.81013Z"
            fill="url(#paint25_radial_9234_68254)"
      />
      <path d="M18.2405 9.80999C18.0405 10.41 17.4405 10.74 16.9005 10.56C16.3605 10.38 16.0905 9.74999 16.2905 9.14999C16.3005 9.12015 16.3114 9.09098 16.3233 9.0625H18.2552C18.3256 9.29223 18.3259 9.55384 18.2405 9.80999Z"
            fill="url(#paint26_radial_9234_68254)"
      />
      <path d="M18.2405 9.80999C18.0405 10.41 17.4405 10.74 16.9005 10.56C16.3605 10.38 16.0905 9.74999 16.2905 9.14999C16.3005 9.12015 16.3114 9.09098 16.3233 9.0625H18.2552C18.3256 9.29223 18.3259 9.55384 18.2405 9.80999Z"
            fill="url(#paint27_linear_9234_68254)"
      />
      <path d="M18.2405 9.80999C18.0405 10.41 17.4405 10.74 16.9005 10.56C16.3605 10.38 16.0905 9.74999 16.2905 9.14999C16.3005 9.12015 16.3114 9.09098 16.3233 9.0625H18.2552C18.3256 9.29223 18.3259 9.55384 18.2405 9.80999Z"
            fill="url(#paint28_linear_9234_68254)"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.9117 7.96584C25.2326 8.22773 25.2805 8.70019 25.0186 9.0211L18.3623 17.1773C18.1004 17.4983 17.628 17.5461 17.3071 17.2842C16.9862 17.0223 16.9383 16.5499 17.2002 16.2289L23.8565 8.0727C24.1184 7.75179 24.5908 7.70394 24.9117 7.96584Z"
            fill="url(#paint29_linear_9234_68254)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.0179 6.03027) rotate(90) scale(20.845 13.3929)"
      >
        <stop stop-color="#BBEEFF" />
        <stop offset="0.519546"
              stop-color="#BAE8FF"
        />
        <stop offset="0.926084"
              stop-color="#B6D9F5"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.0179 19.0627) rotate(90) scale(10.9675 10.9839)"
      >
        <stop offset="0.0756226"
              stop-color="#BAEDFF"
        />
        <stop offset="1"
              stop-color="#BBEEFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint2_linear_9234_68254"
                      x1="9.625"
                      y1="14.4377"
                      x2="10.8125"
                      y2="13.3752"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBD9F3" />
        <stop offset="0.66"
              stop-color="#B9DAF5"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_9234_68254"
                      x1="22.1875"
                      y1="14.3127"
                      x2="21.125"
                      y2="13.4377"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBD9F3" />
        <stop offset="0.66"
              stop-color="#B9DAF5"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint4_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.25 6.85962) rotate(90.0907) scale(0.985535 18.6948)"
      >
        <stop stop-color="#CFF0FF" />
        <stop offset="0.233119"
              stop-color="#C6EDFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.9375 6.68774) rotate(90) scale(0.8125 14.6246)"
      >
        <stop stop-color="#D2F9FF" />
        <stop offset="1"
              stop-color="#C6EDFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint6_linear_9234_68254"
                      x1="10.0205"
                      y1="29.5001"
                      x2="22.0205"
                      y2="29.5001"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BAD8F2" />
        <stop offset="0.118067"
              stop-color="#BDE6FF"
        />
        <stop offset="0.5139"
              stop-color="#C0EFFF"
        />
        <stop offset="0.769108"
              stop-color="#CBF8FF"
        />
        <stop offset="0.907129"
              stop-color="#C9F6FF"
        />
        <stop offset="0.987858"
              stop-color="#C1E3FB"
        />
      </linearGradient>
      <radialGradient id="paint7_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.2811 28.1251) rotate(90) scale(0.78125 6.84375)"
      >
        <stop stop-color="#C3EDFF" />
        <stop offset="1"
              stop-color="#C1EBFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.5623 28.5313) rotate(87.5105) scale(0.719429 4.22291)"
      >
        <stop offset="0.187909"
              stop-color="#D0FCFF"
        />
        <stop offset="0.762564"
              stop-color="#D2FCFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_9234_68254"
                      x1="15.0626"
                      y1="22.9377"
                      x2="17.0371"
                      y2="22.9377"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B8DAF6" />
        <stop offset="0.100054"
              stop-color="#C3EDFF"
        />
        <stop offset="0.339641"
              stop-color="#C4EFFF"
        />
        <stop offset="0.605271"
              stop-color="#CCF7FF"
        />
        <stop offset="0.862565"
              stop-color="#CBF6FF"
        />
        <stop offset="0.949027"
              stop-color="#C3E5FD"
        />
      </linearGradient>
      <radialGradient id="paint10_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.96863 12.594) rotate(142.326) scale(3.11906 28.5061)"
      >
        <stop stop-color="#A3CA95" />
        <stop offset="0.110771"
              stop-color="#A2D788"
        />
        <stop offset="0.390233"
              stop-color="#A9E680"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.7499 13.594) rotate(34.6057) scale(3.79671 34.6994)"
      >
        <stop stop-color="#A3CA95" />
        <stop offset="0.110771"
              stop-color="#A2D788"
        />
        <stop offset="0.296931"
              stop-color="#A9E680"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.8749 12.0627) rotate(50.8696) scale(4.7537 5.32973)"
      >
        <stop stop-color="#A4E170" />
        <stop offset="1"
              stop-color="#A9E680"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint13_linear_9234_68254"
                      x1="16.0156"
                      y1="9.03027"
                      x2="16.0156"
                      y2="10.1877"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A5E294" />
        <stop offset="1"
              stop-color="#ACE3B0"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint14_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.0624 9.71899) rotate(90) scale(0.53125 5.61133)"
      >
        <stop stop-color="#C6FD91" />
        <stop offset="1"
              stop-color="#B9EF82"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint15_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.6561 9.594) rotate(90) scale(0.374995 8.59375)"
      >
        <stop stop-color="#C6FD91" />
        <stop offset="1"
              stop-color="#B9EF82"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint16_linear_9234_68254"
                      x1="18.8437"
                      y1="5.18764"
                      x2="20.0624"
                      y2="5.60951"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E4A671" />
        <stop offset="0.334433"
              stop-color="#FCB17B"
        />
        <stop offset="0.658786"
              stop-color="#FFC991"
        />
        <stop offset="1"
              stop-color="#FDC094"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_9234_68254"
                      x1="19.2812"
                      y1="5.31264"
                      x2="19.2812"
                      y2="7.84389"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.398148"
              stop-color="#FFCD9F"
              stop-opacity="0"
        />
        <stop offset="0.54321"
              stop-color="#FFCA9C"
        />
        <stop offset="0.683333"
              stop-color="#FFCB9C"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint18_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-2.84771 9.03044 -6.43463 -2.46352 18.875 7.50012)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.902919"
              stop-color="#F09BB9"
              stop-opacity="0"
        />
        <stop offset="0.975105"
              stop-color="#F19BB8"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.44887 -3.61786 5.48031 2.81989 17.6563 11.7814)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.109375"
              stop-color="#DB95AB"
        />
        <stop offset="0.208333"
              stop-color="#F09BB9"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint20_linear_9234_68254"
                      x1="15.8437"
                      y1="16.4689"
                      x2="18.0312"
                      y2="10.1251"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF"
              stop-opacity="0.3"
        />
        <stop offset="0.759375"
              stop-color="#FFFFFF"
              stop-opacity="0.3"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint21_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19 9.12518) rotate(137.663) scale(1.9024)"
      >
        <stop stop-color="#43A28A" />
        <stop offset="0.87102"
              stop-color="#44A38B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.0938 9.59381) rotate(102.417) scale(3.48784 5.28897)"
      >
        <stop stop-color="#6AB3A2" />
        <stop offset="0.204998"
              stop-color="#3C9992"
        />
        <stop offset="0.515228"
              stop-color="#398294"
        />
        <stop offset="0.764594"
              stop-color="#6B78C2"
        />
      </radialGradient>
      <linearGradient id="paint23_linear_9234_68254"
                      x1="17.9507"
                      y1="9.06055"
                      x2="17.9507"
                      y2="9.46881"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8AB4A0" />
        <stop offset="0.464195"
              stop-color="#66B19F"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint24_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.9453 9.57819) rotate(90) scale(0.460937 7.53286)"
      >
        <stop stop-color="#77BEAE" />
        <stop offset="0.459435"
              stop-color="#66B19F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint25_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.9373 8.87512) rotate(111.176) scale(1.85964 1.71444)"
      >
        <stop offset="0.0804044"
              stop-color="#F96A45"
        />
        <stop offset="0.641465"
              stop-color="#FF7951"
        />
      </radialGradient>
      <radialGradient id="paint26_radial_9234_68254"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.90625 1.26532 -1.7616 -0.675377 17.7185 9.34375)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0804044"
              stop-color="#F6815D"
        />
        <stop offset="0.641465"
              stop-color="#FF9563"
        />
      </radialGradient>
      <linearGradient id="paint27_linear_9234_68254"
                      x1="17.2655"
                      y1="9.0625"
                      x2="17.2655"
                      y2="9.29687"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E88873" />
        <stop offset="1"
              stop-color="#E68972"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint28_linear_9234_68254"
                      x1="17.2655"
                      y1="9.26562"
                      x2="17.2655"
                      y2="10.609"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0697846"
              stop-color="#FF9F71"
              stop-opacity="0"
        />
        <stop offset="0.232615"
              stop-color="#FF9F71"
        />
        <stop offset="0.378"
              stop-color="#FF9F72"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_9234_68254"
                      x1="24.4375"
                      y1="8.5469"
                      x2="17.7813"
                      y2="16.7031"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_9234_68254">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
